import axios from "axios";
import BASE_URL from "../../config";

const getAuthHeader = () => {
  const tokenData = JSON.parse(localStorage.getItem("authUser") || "{}");
  return {
    'Authorization': `Bearer ${tokenData.accessToken}`,
    'Content-Type': 'application/json'
  };
};

export const getPayrollDetailHistory = async (filter = {}) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/PayrollDetailHistory/get`, {
      payroll_Id: filter.payroll_Id || null,
      employee_Id: filter.employee_Id || null
    }, {
      headers: getAuthHeader(),
    });
    return response.data;
  } catch (error) {
    console.error("[PayrollDetailHistoryAPI] Failed to fetch payroll detail history:", error);
    throw error;
  }
};

// API to export payroll details history report to Excel
export const exportPayrollDetailsHistoryToExcel = async (filter = {}) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/PayrollDetailHistory/export-excel`, {
      payroll_Id: filter.payroll_Id || null,
      business_Id: filter.business_Id || null,
      branch_Id: filter.branch_Id || null,
      department_Id: filter.department_Id || null,
      employee_Id: filter.employee_Id || null
    }, {
      headers: getAuthHeader(),
      responseType: 'blob'
    });
    
    // Create download link
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `PayrollDetailsHistoryReport_${new Date().toISOString().slice(0,19).replace(/[-:]/g, '').replace('T', '_')}.xlsx`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
    
    return true;
  } catch (error) {
    console.error("Error exporting payroll details history report:", error);
    throw error;
  }
}; 